export const SET_ACADEMIC_PROGRAM_CERTIFICATES = 'SET_ACADEMIC_PROGRAM_CERTIFICATES';
